import { MutationTree } from 'vuex'
import {
    UI_SET_SIZE,
    UI_SET_PAGE,
    UI_SET_TREE_OPEN,
    UI_SET_SEARCH_TERM,
    UI_SET_SEARCH_OPEN,
    UI_SET_SEARCH_FOCUS,
    UI_SET_THEME,
    UI_SET_DARKNESS,
    UI_SET_SHOW_STRENGTH_INDICATOR,
    UI_SET_DRAG_DROP_VAULTS,
    UI_SET_SHOW_TOOLTIPS,
    UI_SET_LAST_URL,
    UI_SET_IS_ONLINE
} from '@/store/ui/constants'
import UIState, { UISize, EditorPage, ThemeColour, Darkness } from '@/store/ui/types'
import PStorage, {
    THEME,
    DARKNESS,
    DRAG_DROP_VAULTS,
    SHOW_TOOLTIPS,
    STRENGTH_INDICATOR
} from '@/util/PStorage'

const mutations: MutationTree<UIState> = {
    /**
     * Set interface/window size
     */
    [UI_SET_SIZE](state, newSize: UISize): void {
        state.size = newSize
    },

    /**
     * Set editor page
     */
    [UI_SET_PAGE](state, newPage: EditorPage): void {
        state.page = newPage
    },

    /**
     * Open/close the vault tree (ignored on lg-desktop)
     */
    [UI_SET_TREE_OPEN](state, value: boolean): void {
        state.treeOpen = value
    },

    /**
     * Open/close the search box
     */
    [UI_SET_SEARCH_OPEN](state, value: boolean): void {
        state.searchOpen = value
    },

    /**
     * Focus/blur the search box
     */
    [UI_SET_SEARCH_FOCUS](state, value: boolean): void {
        state.searchFocused = value
    },

    /**
     * Set current search term
     */
    [UI_SET_SEARCH_TERM](state, term: string): void {
        state.searchTerm = term
    },

    /**
     * Set the application theme
     */
    [UI_SET_THEME](state, theme: ThemeColour) {
        state.theme = theme
        PStorage.set(THEME, theme)
    },

    /**
     * Set darkness level
     */
    [UI_SET_DARKNESS](state, darkness: Darkness) {
        state.darkness = darkness
        PStorage.set(DARKNESS, darkness)
    },

    /**
     * Set drag and dropping vaults enabled
     */
    [UI_SET_DRAG_DROP_VAULTS](state, dragDropVaults: boolean) {
        state.dragDropVaults = dragDropVaults
        PStorage.set(DRAG_DROP_VAULTS, dragDropVaults)
    },

    /**
     * Set show tooltips enabled
     */
    [UI_SET_SHOW_TOOLTIPS](state, showTooltips: boolean) {
        state.showTooltips = showTooltips
        PStorage.set(SHOW_TOOLTIPS, showTooltips)
    },

    /**
     * Set darkness level
     */
    [UI_SET_SHOW_STRENGTH_INDICATOR](state, showStrengthIndicator: boolean) {
        state.showStrengthIndicator = showStrengthIndicator
        PStorage.set(STRENGTH_INDICATOR, showStrengthIndicator)
    },

    /**
     * Turn sync capabilities on or off
     */
    [UI_SET_IS_ONLINE](state, isOnline: boolean) {
        state.isOnline = isOnline
    },

    [UI_SET_LAST_URL](state, lastUrl: string) {
        state.lastUrl = lastUrl
    }
}

export default mutations
